import React, { useState, useEffect } from 'react';
import { useForm, ValidationError } from '@formspree/react';

const App = () => {
  const localStorageTransactions = JSON.parse(localStorage.getItem('transactions') || '[]');
  const [transactions, setTransactions] = useState(localStorageTransactions);
  const [description, setDescription] = useState('');
  const [amount, setAmount] = useState(null);
  const [editingTransactionId, setEditingTransactionId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    localStorage.setItem('transactions', JSON.stringify(transactions));
  }, [transactions]);

  const [state, handleSubmit] = useForm("mrgobnlz");

  const [showApp, setShowApp] = useState(true);

  // useEffect(() => {
  useEffect(() => {
    if (state.succeeded) {
      setShowApp(false);

      setTimeout(() => {
        setShowModal(false);
        setShowApp(true);
      }, 2000);
    }
  }, [state.succeeded]);


  const addTransaction = (e) => {
    e.preventDefault();
    if (editingTransactionId) {
      const updatedTransactions = transactions.map((transaction) => {
        if (transaction.id === editingTransactionId) {
          return { id: editingTransactionId, description, amount: +amount };
        }
        return transaction;
      });
      setTransactions(updatedTransactions);
      setEditingTransactionId(null);
    } else {
      setTransactions([...transactions, { id: Date.now(), description, amount: +amount }]);
    }
    setDescription('');
    setAmount(0);
  };

  const deleteTransaction = (id) => {
    setTransactions(transactions.filter((t) => t.id !== id));
  };

  const editTransaction = (transaction) => {
    setEditingTransactionId(transaction.id);
    setDescription(transaction.description);
    setAmount(transaction.amount);
  };


  return (
    <>
      {showApp ?
        (
          <div className="relative bg-gray-200 min-h-screen" >
            <h1 className="text-3xl font-bold text-center pt-12">Personal Finance Tracker</h1>
            <div className='flex mt-4 justify-center items-center'>
              <button
                className="bg-indigo-500 hover:bg-indigo-300 text-white font-bold py-2 px-4 rounded inline-flex items-center mr-4"
                onClick={() => setShowModal(true)}
              >
                Subscribe
              </button>
              <button
                className="bg-indigo-500 hover:bg-indigo-300 text-white font-bold py-2 px-4 rounded inline-flex items-center"

              >
                <a href="https://ko-fi.com/nitinfab" >Give a tip</a>
              </button>
            </div>
            {showModal && (
              <div className="fixed shadow-md top-0 left-0 right-0 bottom-0 bg-gray-400 opacity-100">
                <div className="flex flex-col justify-center items-center relative mx-4 md:mx-auto  mt-60 p-6 rounded w-full md:w-1/2 xl:w-1/3 bg-white shadow-xl">

                  <form onSubmit={handleSubmit} class="bg-white px-8 pt-6 pb-8 mb-4">
                    <div className="text-xl font-medium mb-6">Get Notified for More Such App!!!</div>
                    <div class="mb-4">
                      <label class="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                        Email Address
                      </label>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      />
                      <ValidationError
                        prefix="Email"
                        field="email"
                        errors={state.errors}
                      />
                    </div>
                    <div class="mb-4">
                      <label class="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                        Comments
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        className="border border-slate-300 rounded-md shadow appearance-none w-full pt-2  px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                      />
                      <ValidationError
                        prefix="Message"
                        field="message"
                        errors={state.errors}
                      />
                    </div>
                    <div className='flex'>
                      <button
                        className="bg-indigo-500 hover:bg-indigo-300 text-white font-bold py-2 px-4 rounded inline-flex items-center"
                        type="submit" disabled={state.submitting}>
                        Submit
                      </button>
                      <button
                        className="ml-4 bg-indigo-500 hover:bg-indigo-300 text-white font-bold py-2 px-4 rounded inline-flex items-center"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>

                {/* </div> */}
              </div>


            )}
            <div className="container mt-8  mx-auto px-5">
              <div className="p-5 bg-white rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold text-center mb-5">Transactions</h2>
                <table className="w-full table-fixed flex flex-col items-between text-left">
                  <thead>
                    <tr className='flex w-full justify-between'>
                      <th className="sm:text-xl text-md font-bold w-full md:w-1/4 px-2 py-2">Description</th>
                      <th className="sm:text-xl text-md font-bold w-full md:w-1/4 px-2 py-2">Amount</th>
                      <th className="sm:text-xl text-md font-bold w-full md:w-1/4 px-2 py-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((t) => (
                      <tr key={t.id} className='flex w-full justify-between'>
                        <td className="py-2 px-2 w-full md:w-1/4">{t.description}</td>
                        <td className="py-2 px-2 w-full md:w-1/4">${t.amount}</td>
                        <td className="py-2 px-2 w-full md:w-1/4">
                          <button className="mb-4 sm:mb-0 bg-yellow-500 px-4 py-2 text-white" onClick={() => editTransaction(t)}>
                            Edit
                          </button>
                          <button className="bg-red-500 px-4 py-2 text-white mr-2" onClick={() => deleteTransaction(t.id)}>
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className='mt-16 mb-4 w-full lg:w-1/2 xl:w-1/3 p-5 mx-auto rounded shadow-lg  border border-gray-100  '>
                  <h1 className="text-xl font-bold text-center mb-5">Add Your Transactions</h1>
                  <form className="flex text-center flex-col  mx-auto border-1 border-double  border-indigo-600 w-full  justify-between my-5" onSubmit={addTransaction}>
                    <input
                      type="text"
                      className="border border-slate-300 rounded-md w-full px-2 py-2 mb-2"
                      placeholder="Description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                    <input
                      type="number"
                      className="border border-slate-300 rounded-md w-full px-2 py-2 mb-2"
                      placeholder="Amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                    <button className="bg-violet-500 hover:bg-violet-600 active:bg-violet-700 focus:outline-none focus:ring focus:ring-violet-300 px-4 py-2 text-white" type="submit">
                      Add Transaction
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div >) :
        <section class="text-gray-600 body-font">
          <div class="container px-5 py-24 mx-auto">
            <div class="flex flex-col text-center w-full mb-12">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Thanks for Joining!</h1>
              <p class="lg:w-2/3 mx-auto leading-relaxed text-base">You will recieve update whenever I create a new app like this.</p>
            </div>
          </div>
        </section>}
    </>


  );

};

export default App;

